import { ISaveTreinamentoFuncionarioUseCase } from "../../../presentation/useCases/create/save_treinamento_funcionario_use_case";
import { IRhRepository } from "../../repositories/rh_repository";

/**
 * SaveTreinamentoFuncionarioUseCase
 */

export class SaveTreinamentoFuncionarioUseCase implements ISaveTreinamentoFuncionarioUseCase {
  constructor(private readonly repository: IRhRepository) { }

  async saveTreinamentoFuncionario(
    treinamentoIds: number[],
    funcionarioIds: number[],
    dataRealizacao: Date,
    local: string,
    instrutor: string,
    prazoAvaliacao: number,
    instrutorAssinatura1: number | null,
    instrutorAssinatura2: number | null,
    instrutorAssinatura3: number | null,
  ): Promise<void> {
    await this.repository.saveTreinamentoFuncionario(
      treinamentoIds,
      funcionarioIds,
      dataRealizacao,
      local,
      instrutor,
      prazoAvaliacao,
      instrutorAssinatura1,
      instrutorAssinatura2,
      instrutorAssinatura3,
    );
  }
}
